import { Chatbot } from "@zapier/chatbots-tailwind";
import { useChatbotTailwindProps } from "./useChatbotTailwindProps";
import { ChatbotWrapper } from "./ChatbotWrapper";
import { type MouseEventHandler } from "react";
import { type ChatbotBlock } from "../types";

/**
 * 130px is the vertical padding of the published interface Page.
 * See packages/service/src/components/Page/Page.tsx.
 **/
const DEFAULT_HEIGHTS = {
  maxHeight: "calc(100vh - 130px)",
  height: "initial",
};

function useBlockStyle(props: {
  block: { config: { style?: { height?: string; heightValue?: number } } };
}) {
  if (props.block.config.style?.height === "custom") {
    if (!props.block.config.style?.heightValue) {
      return DEFAULT_HEIGHTS;
    }

    return {
      maxHeight: `${props.block.config.style.heightValue}px`,
      height: `${props.block.config.style.heightValue}px`,
    };
  }

  return DEFAULT_HEIGHTS;
}

export default function ChatbotTailwind({
  loadingSlot: Spinner,
  disabledSlot: Disabled,
  handlePopupCloseButtonClick,
  ...props
}: {
  block: ChatbotBlock;
  blockId: string;
  loadingSlot: React.FunctionComponent;
  disabledSlot: React.FunctionComponent;
  handlePopupCloseButtonClick?: MouseEventHandler<HTMLButtonElement>;
}) {
  const blockStyle = useBlockStyle(props);
  const chatbotTailwindProps = useChatbotTailwindProps(props);

  return (
    <ChatbotWrapper
      isEditing={Boolean(chatbotTailwindProps.isEditing)}
      isPopup={chatbotTailwindProps.isPopup}
      style={blockStyle}
      key={props.block.config.id}
    >
      <Chatbot
        {...chatbotTailwindProps}
        loadingSlot={Spinner}
        disabledSlot={Disabled}
        handlePopupCloseButtonClick={handlePopupCloseButtonClick}
      />
    </ChatbotWrapper>
  );
}
